import { app } from '../../../app';

app.factory('UsersSharedAccountService', UsersSharedAccountService);

/** @ngInject */
function UsersSharedAccountService($resource) {
    var rootUrl = 'app/rest/corporateServices';
    return {
        usersCompanySharedAccounts : $resource(rootUrl),
        userSharedAccountSSO : $resource(rootUrl + '/:id', {
            id : '@id'
        }, {
            'query' : {
                method : 'GET',
                isArray : true
            },
            'get' : {
                method : 'GET'
            },
            'getTracker' : {
                method : 'GET',
                url : 'app/rest/corporateServices/tracker/:id',
                isArray : false,
                params : {
                    id : '@id',
                },
                transformResponse : function(data, headers) {
                    return {
                        tracker : data,
                        shared : true
                    };
                }
            }
        }),
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.service.js